module.exports = __webpack_public_path__ + "img/ZA.0239bf94.svg";